import axios from "axios";
import { API_PATHS } from "../../paths";
import LatestNews from "../../Model/LatestNewsModel";
import { flashMessage } from "../../../utils/flashMessageService";

/**
 * GET /api/latestnews
 */
export async function fetchLatestNews(payload = {}) {
	try {
		const res = await axios.get(API_PATHS.latestNews, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
			params: payload,
		});
		const items = res.data || [];
		return items.map((i) => LatestNews.fromJSON(i));
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error("fetchLatestNews failed with status 400:", error.response.data);
			flashMessage(`fetchLatestNews failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error("Error fetching latest news:", error);
			flashMessage("fetchLatestNews failed. Please try again.", { type: "error" });
		}
		console.error("fetchLatestNews error:", error);
		throw error;
	}
}

/**
 * POST /api/latestnews
 */
export async function createLatestNews(payload = {}) {
	try {
		// If caller passed a FormData instance, use it directly
		const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
		const body = isFormData ? payload : (() => {
			const fd = new FormData();
			Object.entries(payload).forEach(([k, v]) => {
				if (v !== undefined && v !== null) fd.append(k, v);
			});
			return fd;
		})();

		const res = await axios.post(API_PATHS.latestNews, body, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("authToken")}`,
				"Content-Type": "multipart/form-data",
			},
		});
		flashMessage("Latest news created successfully.", { type: "success" });
		return LatestNews.fromJSON(res.data);
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error("createLatestNews failed with status 400:", error.response.data);
			flashMessage(`createLatestNews failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error("Error creating latest news:", error);
			flashMessage("createLatestNews failed. Please try again.", { type: "error" });
		}
		console.error("createLatestNews error:", error);
		throw error;
	}
}

/**
 * GET /api/latestnews/:id
 */
export async function fetchLatestNewsById(id) {
	try {
		const res = await axios.get(API_PATHS.latestNewsById(id), {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		});
		return LatestNews.fromJSON(res.data);
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error(`fetchLatestNewsById(${id}) failed with status 400:`, error.response.data);
			flashMessage(`fetchLatestNewsById failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error(`Error fetching latest news by ID (${id}):`, error);
			flashMessage("fetchLatestNewsById failed. Please try again.", { type: "error" });
		}
		console.error(`fetchLatestNewsById(${id}) error:`, error);
		throw error;
	}
}

/**
 * PUT /api/latestnews/:id
 */
export async function updateLatestNews(id, payload = {}) {
	try {
		const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
		const body = isFormData ? payload : (() => {
			const fd = new FormData();
			Object.entries(payload).forEach(([k, v]) => {
				if (v !== undefined && v !== null) fd.append(k, v);
			});
			return fd;
		})();

		const res = await axios.put(API_PATHS.latestNewsById(id), body, {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("authToken")}`,
				"Content-Type": "multipart/form-data",
			},
		});
		flashMessage("Latest news updated successfully.", { type: "success" });
		return LatestNews.fromJSON(res.data);
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error("updateLatestNews failed with status 400:", error.response.data);
			flashMessage(`updateLatestNews failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error("Error updating latest news:", error);
			flashMessage("updateLatestNews failed. Please try again.", { type: "error" });
		}
		console.error(`updateLatestNews(${id}) error:`, error);
		throw error;
	}
}

/**
 * DELETE /api/latestnews/:id
 */
export async function deleteLatestNews(id) {
	try {
		const res = await axios.delete(API_PATHS.latestNewsById(id), {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		});
		flashMessage("Latest news deleted successfully.", { type: "success" });
		return res.data;
	} catch (error) {
		if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
			console.error(`deleteLatestNews(${id}) failed with status 400:`, error.response.data);
			flashMessage(`deleteLatestNews failed: ${error.response.data.error}`, { type: "error" });
		} else {
			console.error(`Error deleting latest news (${id}):`, error);
			flashMessage("deleteLatestNews failed. Please try again.", { type: "error" });
		}
		console.error(`deleteLatestNews(${id}) error:`, error);
		throw error;
	}
}

